import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoyaltyMembership, QivosCloudService } from '@qivos/qivoscloud-ng-api';
import { catchError, map, of, switchMap } from 'rxjs';
import {
  searchPersonByTelephone,
  searchPersonByTelephoneFail,
  searchPersonByTelephoneSuccess,
  updateMemberFailed,
  updateMemberSuccess,
  updatePerson,
  updatePersonFailed,
  updatePersonSuccess,
} from '../actions/member-details-form.actions';

@Injectable()
export class MemberDetailsEffects {
  constructor(
    private actions$: Actions,
    public qcService: QivosCloudService,
    private router: Router
  ) {}

  authByToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchPersonByTelephone),
      switchMap(({ mobileNumber }) =>
        this.qcService.searchPersonByTelephone(mobileNumber).pipe(
          switchMap((res) =>
            of(searchPersonByTelephoneSuccess({ persons: res?.payload.data }))
          ),
          catchError((error) => of(searchPersonByTelephoneFail(error)))
        )
      )
    )
  );

  onEmailExists$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(searchPersonByTelephoneSuccess),
        map((m) => {
          if (
            m.persons !== undefined &&
            m.persons[0].emailList !== undefined &&
            m.persons[0].emailList.length > 0
          ) {
            this.router.navigate(['email-already-exists']);
          }
        })
      );
    },
    { dispatch: false }
  );

  updatePerson$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updatePerson),
      switchMap(({ person }) =>
        this.qcService.updatePerson(person).pipe(
          switchMap((res) => of(updatePersonSuccess({ person: res?.payload }))),
          catchError((error) => of(updatePersonFailed(error)))
        )
      )
    )
  );

  onUpdateSuccessRedirect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(updatePersonSuccess),
        map(() => {
          this.router.navigate(['register-successfully']);
        })
      );
    },
    { dispatch: false }
  );
}
